import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';
import { createConfiguration } from '../../../workflowConfigurations/actions';
import { selectedWorkflowId } from '../../getters';
import { createConfigurationFieldForWorkflow } from '../../../workflows/actions';
// import state from './state';
// import {} from './mutations';
// import {} from './getters';

const buildSelectedWorkflowConfigurationsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const createConfigurationForSelectedWorkflow = buildSelectedWorkflowConfigurationsActionObject(
	'createConfigurationForSelectedWorkflow'
);
export const createConfigurationFieldForSelectedWorkflow = buildSelectedWorkflowConfigurationsActionObject(
	'createConfigurationFieldForSelectedWorkflow'
);

const actions = {
	...StoreModuleService.createDefaultActions(),
	[createConfigurationForSelectedWorkflow.action]({ dispatch, rootGetters }, payload) {
		return dispatch(createConfiguration.fullPath, { ...payload, workflowId: rootGetters[selectedWorkflowId.fullPath] }, { root: true });
	},
	async [createConfigurationFieldForSelectedWorkflow.action]({ dispatch, rootGetters }, payload) {
		const field = await dispatch(
			createConfigurationFieldForWorkflow.fullPath,
			{ ...payload, id: rootGetters[selectedWorkflowId.fullPath] },
			{ root: true }
		);
		return field;
	},
};

export default actions;
